module.exports = __webpack_public_path__ + "static/media/trend-up-01.1956be48.svg";